<template>
    <div>
        <div class="select-box">
            <div ref="card" class="products-container">
                <div v-for="item in options" :key="`${item.product_family}-${item.id}`" @click="selectCard(item)">
                    <div v-if="displayBox(item) && notShowBussinessBumper(item)" class="card" :class="{ active: checked(item) }">
                        <img class="image" :src="imageURL(item)" :alt="`${item.display_name} box image`">
                        <div class="input__radio radio-button">
                            <input class="input__radio-item m-1" type="radio" :id="item.id"  :value="item.product_family" :checked="checked(item)">
                            <label :for="item.id" class="input__radio-label"></label>
                        </div>
                        <div class="content">
                            <p class="title">{{item.display_name}}</p>
                            <p class="subTitle">{{currency}}{{ getSubscriptionPrice(item.price) }}</p>
                            <div class="full-text">
                                <p class="text-size" v-if="item.product_family === 'lite'">{{$t('RESTART_PAGE_SIZE')}}</p>
                                <p class="text-size" v-if="item.product_family === 'standard'">{{$t('RESTART_PAGE_VALUE')}}</p>
                                <p class="text-size" v-if="item.product_family === 'bumper'">{{$t('RESTART_PAGE_FROM')}}</p>
                                <p class="badge" v-if="activeSubscription && selected.product_family === item.product_family">{{$t('CURRENT_BOX')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-info" :class="{'box-pop-info' : !essentialEnabled && !showPop }">
            {{ $t('RESTART_PAGE_PRICE_INCLUDED') }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SelectBox',
    props: {
        options: {
            require: true,
            type: Array,
        },
        selected: {
            require: false,
            type: Object,
            default: null,
        },
        showPop: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            value: this.selected,
            isSelected: false,
        };
    },
    mounted() {
        this.$refs.card.scrollLeft += 145;
        this.$emit('input', this.selected);
        this.value = this.selected;
    },
    computed: {
        ...mapGetters({
            essentialEnabled: 'account/getEssentialBoxRestart',
            activeSubscription: 'subscription/getActiveSubscription',
            currency: 'localisation/getCurrency',
        }),
    },
    methods: {
        imageURL(item) {
            return item.image_url || require(`@/assets/images/products/${item.product_family?.toLowerCase()}.jpg`);
        },
        selectCard(item) {
            this.value = item;
            this.$emit('input', item);
        },
        scroll(val) {
            this.$refs.card.scrollLeft += 125 * val;
        },
        displayBox(item) {
            return (item.product_family !== 'lite') || (item.product_family === 'lite' && this.essentialEnabled) || (item.product_family === 'lite' && this.showPop);
        },
        notShowBussinessBumper(item) {
            return item.product_family !== 'business-bumper';
        },
        handleResize() {
            this.window.width = window.innerWidth;
        },
        getSubscriptionPrice(price) {
            return parseInt(price) + parseInt(process.env.VUE_APP_DELIVERY_PRICE_NP_4 || 0);
        },
        checked(item) {
            return this.value?.product_family.toLowerCase() === item.product_family.toLowerCase();
        },
    },
};
</script>

<style lang="scss" scoped>
.select-box {
    position: relative;
    width: 78vw;
}
@media (min-width:740px) {
   .select-box {
     width: 612px;
   }
}
.products-container {
    padding: 0;
    display: flex;
    overflow-x: scroll;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
    scroll-padding: 15vw;
    width: 80vw;
    height: 100%;
    gap: 18px;
}

@media (min-width: 740px) {
        .products-container {
            width: 612px;
            overflow: hidden;
        }
    }

.card {
    scroll-snap-align: start;
    border: 1px solid #CECECE;
    border-radius: 8px;
    height: 100%;
    padding: 5px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 188px;
    padding-bottom: 27px;
    @media (min-width: 740px) {
        min-width: calc(33% - 10px);
    }
}

.content {
    margin-left: 0;
    text-align: center;
}
.image {
    width: 171px;
    height: 172px;
    margin: 5px auto;
    @media (min-width: 740px) {
        width: 100%;
    }
}
.title {
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
}
.subTitle {
    font-size: 18px;
    line-height: 20px;
    text-align: center;
}
.badge {
    padding-left: 20px;
    padding-right: 17px;
    font-size: 18px;
    padding-top: 4px;
    background-color: #dfdfdf;
    border-radius: 80px;
    width: 130px;
}
.radio-button {
    margin: 6px;
}
.right-scroll, .left-scroll {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%
}
.left-scroll {
    left: -15px;
    cursor: pointer;
}
.right-scroll {
    right: -15px;
    cursor: pointer;
}

.align-center-radio {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.box-info {
    position: relative;
    left: -5px;
    background-color: #F6F6F6;
    border-radius: 24px;
    width: 350px;
    height: 40px;
    margin: 24px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Gill Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
}

@media (min-width: 740px) {
    .box-info {
        width: 620px;
    }
}

@media (max-width: 768px) {
    .products-container {
        width: 91vw;
        height: 100%;
    }
    .box-info {
        width: 90vw;
        left: 0px;
    }
}

.text-size {
    font-size: 18px;
    font-weight: 300px;
    padding-bottom: 39px;
    width: 155px;
    height: 60px;
    line-height: 24px;
    padding-bottom: 4px;
}
.active {
    opacity: 1;
    border: 2px solid #1a1a1a;
}
.full-text {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.box-pop-info {
    display: 612px;
}
@media (min-width: 740px) {
    .box-pop-info {
        width: 450px;
    }
}
@media (min-width: 768px) {
    .box-pop-info {
        width: 450px;
    }
}
</style>
